import { $Color } from '@suntex.core/types';

import { standardizeNode } from '../utils/standardizeNode';

import { algebraGoalsNode } from './views/algebra-goals';
import { fractionsFestNode } from './views/fractions-fest';
import { mathObjectivesNode } from './views/math-objectives';
import { modulesNode } from './views/modules';
import { stagesOfLearningNode } from './views/stages-of-learning';
import { topGamesNode } from './views/top-games';

const COMPASS_COLOR = $Color.from('#9f92ff');

export const rootRadialData = standardizeNode(
  {
    key: '',
    tag: '',
    label: {
      aria: 'Compass',
    },
    icon: 'compass',
    hideProgressBar: true,
    layout: 'anchor',
    children: [
      stagesOfLearningNode,
      modulesNode,
      mathObjectivesNode,
      fractionsFestNode,
      algebraGoalsNode,
      topGamesNode,
    ],
  },
  { path: '', color: COMPASS_COLOR, index: 0 },
);
